import UserAvatar from "../common/UserAvatar";
import Username from "../common/Username";
import ThreadPromoteInfo from "../Thread/section/ThreadPromoteInfo";
import HtmlParsedText from "../common/HtmlParsedText";
import PostActionButtons from "./section/PostActionButtons";
import {convertReactionUsersToReactionData} from "../../utils/user";
import RatingStars from "../common/RatingStars";

const PostUser = ({post}) => {
	return (
		<>
			<a href={post.User ? post.User.view_url : '#'} title={post.username}
			   className="block w-[48px] h-[48px] mb-2 lg:mx-auto lg:w-[96px] lg:h-[96px]">
				<UserAvatar user={post.User} />
			</a>

			<div>
				<p className="mb-2 overflow-hidden max-w-full">
					<Username user={post.User} />
				</p>

				{post.User && (
					<p className="text-sm text-white">
						{post.User.custom_title ? post.User.custom_title : post.User.user_title}
					</p>
				)}
			</div>
		</>
	)
}

const PostHeader = ({post, isRating}) => {
	return (
		<div className="flex items-center text-sm text-url">
			{!isRating && (
				<span>{post.post_date}</span>
			)}

			{isRating && (
				<RatingStars score={post.rating} />
			)}
		</div>
	);
}

const Post = ({post, postId, thread = null, isRating = false}) => {
	return (
		<div className={`border border-borderColor flex flex-wrap rounded-lg ${post.is_deleted && 'is-deleted'}`}>
			<div className="w-full flex gap-x-2 bg-primary bg-opacity-85 p-2 flex-shrink-0 flex-grow-0 lg:block lg:w-[160px] lg:text-center">
				<PostUser post={post} />
			</div>

			<div className="flex-1 p-4 min-w-0">
				<div className="flex flex-col h-full">
					{(post.is_first_post || isRating) && (
						<div className="mb-2">
							<PostHeader post={post} isRating={isRating} />
						</div>
					)}

					{(!isRating && post.is_first_post && thread.is_promote && (thread.ft_temp_off || thread.discussion_open !== true)) && (
						<div className="mt-4 p-2 bg-secondary text-red-500 font-bold text-xl">
							Tạm nghỉ
						</div>
					)}

					{!isRating && post.is_first_post && thread && (thread.is_promote || thread.is_reviews) && (
						<div className="border border-borderColor p-2 mb-2 md:p-4">
							<ThreadPromoteInfo thread={thread} />
						</div>
					)}

					<div className="relative h-auto flex-grow flex-shrink">
						<div className={`text-white ${post.is_deleted && 'line-through opacity-65'}`}>
							<HtmlParsedText text={post.message_parsed} isPostContent={true} />
						</div>
					</div>

					<div>
						<PostActionButtons
							post={post}
							postId={postId}
							canReact={post.can_react}
							initialReactionsData={convertReactionUsersToReactionData(post.reaction_users)}
							initialReactionScore={post.reaction_users ? Object.values(post.reaction_users).length : 0}
							isReactedTo={post.is_reacted}
							customApiRoute={isRating ? 'bratr-ratings' : null}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Post;